import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { FormGroup, FormControl, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreButtonComponent, CustomDateFormatPipe],
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss'],
})
export class TransactionsComponent implements OnInit {
  @ViewChild('fromDate', { static: false }) fromDate: ElementRef;
  @ViewChild('toDate', { static: false }) toDate: ElementRef;
  @Input() policy: any;
  transactionFormGroup: FormGroup;
  transactions: any;
  nextBill: any;
  showLoadTransaction: boolean;
  loadedTransactions: any;
  remainingTransactions: any;
  filteredTransaction: boolean;
  totalTransactions: any;
  buttonEnabled: boolean;
  isAcmic: boolean;
  isIOS: boolean;

  constructor(private router: Router, private acmicService: AcmicService) {
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  getLatestScheduledBill() {
    if (this.policy.scheduleBills) {
      this.nextBill = this.policy.scheduleBills
        .filter((e) => {
          return e.invoiceState == 'Planned';
        })
        .sort(function compare(a, b) {
          const dateA: any = new Date(a.dateDue);
          const dateB: any = new Date(b.dateDue);
          return dateA - dateB;
        })[0];
    } else {
      this.nextBill = null;
    }
  }

  openDatePicker(inputType: 'from' | 'to') {
    const inputRef = inputType === 'from' ? this.fromDate : this.toDate;
    if (inputRef?.nativeElement) {
      // On iOS, programmatic events don't reliably open the date picker
      // The CSS handles this by making the icon pointer-events: none on iOS
      // so clicks pass through to the input
      if (this.isIOS) {
        // Just focus the input on iOS - the click will pass through from the icon
        inputRef.nativeElement.focus();
        return;
      }

      // For desktop browsers, use showPicker API or click
      if (typeof inputRef.nativeElement.showPicker === 'function') {
        try {
          inputRef.nativeElement.showPicker();
        } catch {
          // Fallback if showPicker fails
          inputRef.nativeElement.focus();
          inputRef.nativeElement.click();
        }
      } else {
        // Fallback for browsers without showPicker
        inputRef.nativeElement.focus();
        inputRef.nativeElement.click();
      }
    }
  }

  loadTransactions() {
    this.remainingTransactions = this.remainingTransactions - 5;
    this.viewLoadTransaction();
    this.transactions = this.totalTransactions.slice(
      0,
      this.totalTransactions.length - this.remainingTransactions
    );
  }

  viewLoadTransaction() {
    if (this.remainingTransactions > 0) {
      this.showLoadTransaction = true;
    } else {
      this.showLoadTransaction = false;
    }
  }

  goToFAQ() {
    this.router.navigate(['/faq']);
  }

  goToDocuments() {
    this.router.navigate([
      '/my-insurance',
      this.policy.policynumber.policyNumber,
      'documents',
    ]);
  }

  filterTransactions() {
    this.transactions = this.policy.transactions
      .filter((transaction) => {
        return (
          transaction.transactionDate >= this.fromDate.nativeElement.value &&
          transaction.transactionDate <= this.toDate.nativeElement.value
        );
      })
      .reverse();
    this.calculateTransaction(this.transactions, this.transactions.length);
  }

  calculateTransaction(transaction, count) {
    this.remainingTransactions = count - 5;
    this.totalTransactions = transaction.slice();
    this.transactions = transaction.slice(0, 5);
    this.viewLoadTransaction();
  }

  compareDates() {
    const fromDate = this.fromDate.nativeElement.value.replace(/\D/g, '');
    const toDate = this.toDate.nativeElement.value.replace(/\D/g, '');
    if (fromDate > toDate) {
      this.buttonEnabled = false;
    } else {
      this.buttonEnabled = true;
    }
  }

  setFormGroup() {
    this.transactionFormGroup = new FormGroup({
      fromDate: new FormControl('', Validators.required),
      toDate: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.getLatestScheduledBill();
    this.setFormGroup();
    let transactions: [] = null;
    if (this.policy.transactions) {
      transactions = this.policy.transactions.slice();
      this.transactions = transactions.slice().reverse();
    }
    this.isAcmic = this.acmicService.isACMIC();
    if (this.transactions && this.transactions.length > 5) {
      this.showLoadTransaction = true;
    } else {
      this.showLoadTransaction = false;
    }
    this.loadedTransactions = 5;
    if (this.transactions) {
      this.calculateTransaction(this.transactions, this.transactions.length);
    }
  }
}
